<template>
  <div class="hello">
    <van-nav-bar
      title=""
      left-text=""
      left-arrow
      @click-left="onClickLeft"
      @click-right="onClickRight"
    >
      <template #left>
        <van-icon name="arrow-left" color="Gray" size="18" />
      </template>
    </van-nav-bar>
    <div class="van-doc-demo-block" style="margin-top: 20px">
      <h2 class="van-doc-demo-block__title">
        你好，<br /><br />请输入下列所有信息
      </h2>
    </div>
    <van-form class="van-form" style="margin-top: 20px" @submit="onSubmit">
      <van-field
        readonly
        clickable
        name="xiaoqu"
        :value="xiaoqu"
        label="选择学校"
        placeholder="请选择所属学校"
        @click="showPicker = true"
        style="margin-top: 20px"
      />
      <van-popup v-model="showPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="columns"
          value-key="tname"
          @confirm="onConfirm1"
          @cancel="showPicker = false"
        />
      </van-popup>
      <van-field
        v-model="username"
        name="username"
        placeholder="请输学生姓名"
        :rules="[{ required: true, message: '请输学生姓名' }]"
      />
      <van-field
        v-model="number"
        name="number"
        placeholder="请输入学号"
        :rules="[{ required: true, message: '请输入学号' }]"
        style="margin-top: 20px"
      />
      <van-field
        v-model="phone"
        name="phone"
        placeholder="请输入密码"
        :rules="[{ required: true, message: '请输入密码' }]"
        style="margin-top: 20px"
      />
      <div style="margin: 16px; margin-top: 40px">
        <van-button round block type="info" native-type="submit">
          注册
        </van-button>
      </div>
    </van-form>
  </div>
</template>
<script>
export default {
  data() {
    return {
      username: "",
      phone: "",
      number: "",
      shenfen: "",
      xiaoqu: "",
      xiaoquid: "",
      openid: "",
      code: "",
      user: "",
      columns: [],
      showPicker: false,
    };
  },
  created() {
    this.onload();
    //添加学校数据操作以下
  },
  methods: {
    onload() {
      this.code = this.$route.query.code;
      this.shenfen = this.$route.query.shenfen;
      this.openid = this.$route.query.openid;
      this.xiaoqu = this.$route.query.xiaoqu;
      this.xiaoquid = this.$route.query.xiaoquid;
      var params_json = {
        userid: "",
        action: "schoolList",
        param1: "",
        param2: "",
        param3: "",
        param4: "",
        param5: "",
      };
      // console.log(params_json);
      this.$http.post("/web/list", params_json).then(function (res) {
        console.log(res.data["rows"]);
        this.columns = res.data["rows"];
      });
    },
    onConfirm1(value) {
      console.log(value.cityName + value.id);
      this.xiaoqu = value.cityName;
      this.xiaoquid = value.id;
      this.showPicker = false;
    },
    onSubmit(values) {
      console.log("submit", values);
      console.log("学生姓名:", values.username);
      let _this = this;
      var params_json = {
        userid: "",
        action: "regStudent",
        param1: values.username,
        param2: values.phone,
        param3: values.number,
        param4: this.xiaoquid,
        param5: this.openid,
      };
      this.$http.post("/web/save", params_json).then(function (res) {
        let obj = res.data.msg.split("#");
        let code = obj[0];
        let desc = obj[1]; //成功时：部门名称 失败时：失败原因
        if (code == "0") {
          this.user = [
            {
              // username: values.username,
              // number: values.number,
              // shenfen: this.shenfen,
              // phone: values.phone,
              // openid: this.openid,
              username: values.username,
              number: values.number,
              shenfen: this.shenfen,
              phone: values.phone,
              xiaoqu: this.xiaoqu,
              xiaoquid: this.xiaoquid,
              openid: this.openid,
              dep: desc,
            },
          ];
          window.localStorage.setItem("User", JSON.stringify(this.user));
          //获取个人照片
          _this.getPic(values.number);
          this.$notify({
            type: "success",
            message: "注册成功。",
          });
          setTimeout(() => {
            this.$router.push({
              path: "Index",
              query: {
                openid: this.openid,
              },
            });
          }, 1000);
        } else {
          this.$notify({
            type: "warning",
            message: desc,
          });
          // location.reload();
        }
      });
    },
    getPic(pid) {
      var params_json = {
        userid: this.openid,
        action: "getPic",
        param1: pid,
        param2: "",
        param3: "",
        param4: "",
        param5: "",
      };
      this.$http.post("/web/list", params_json).then(function (res) {
        if (res.data["rows"].length > 0) {
          let img = res.data["rows"][0]["pic"];
          window.localStorage.setItem(pid, img);
        }
      });
    },
    onClickLeft() {
      // 成功通知
      //   this.$notify({ type: "success", message: "后退" });
      this.$router.push("LoginType");
      // Notify({type:"success",message:"后退"});
    },
    onClickRight() {
      // 危险通知
      this.$toast("失败文案");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.van-doc-demo-block__title {
  margin: 0;
  padding: 32px 16px 16px;
  color: rgba(69, 90, 100, 0.6);
  font-weight: normal;
  font-size: 16px;
  line-height: 16px;
  font-weight: bold;
}

.van-doc-demo-block__card {
  margin: 12px 12px 0;
  overflow: hidden;
  border-radius: 8px;
}

.van-doc-demo-block__title + .van-doc-demo-block__card {
  margin-top: 0;
}

.van-doc-demo-block:first-of-type .van-doc-demo-block__title {
  padding-top: 20px;
}
</style>
<style>
.demo-col {
  background: #fff;
}

.demo-col .van-doc-demo-block {
  padding: 0 16px;
}

.demo-col .van-doc-demo-block__title {
  padding-left: 0;
}

.demo-col .van-col {
  margin-bottom: 10px;
  color: #fff;
  font-size: 13px;
  line-height: 30px;
  text-align: center;
  background-clip: content-box;
}

.demo-col .van-col:nth-child(odd) {
  background-color: #39a9ed;
}

.demo-col .van-col:nth-child(even) {
  background-color: #66c6f2;
}
</style>